import moment from "moment";
import api from "./api";

const F_SYSTEM_SETTING_NAME = {
  "0518": "limitOverExceed",
};

export interface FSystem {
  limitOverExceed: number;
}

class CommonApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async calendar(query): Promise<any> {
    const response = await this.getHttp().get<any>("common/calendar", {
      params: query,
    });

    return response.data.data.map((item) => {
      item.date_object = moment(item.date).toDate().toISOString();
      return item;
    });
  }

  async setting(query): Promise<any> {
    const response = await this.getHttp().get<any>("admin/settings", {
      params: query,
    });
    const result = {};
    response.data.data.map((item) => {
      result[item.name] = item.value - 0;
    });

    return result;
  }

  async shippingFeeByPref(query): Promise<any> {
    const response = await this.getHttp().get<any>(
      "common/shipping-fee/" + query.id,
      {
        params: query,
      }
    );

    return response.data.data;
  }

  async sagawaPostal(query): Promise<any> {
    const response = await this.getHttp().get<any>(
      "common/sagawa-postals/" + query.code
    );

    return response.data.data;
  }

  async tax(query): Promise<any> {
    const response = await this.getHttp().get<any>("common/tax", {
      params: query,
    });

    return response.data.data;
  }
  async fSystem(query): Promise<any> {
    const response = await this.getHttp().get<any>("common/f-systems", {
      params: query,
    });

    const result = {};
    response.data.data.map((item) => {
      if (F_SYSTEM_SETTING_NAME[item.id]) {
        result[F_SYSTEM_SETTING_NAME[item.id]] = item.value;
      }
    });

    return result;
  }
}
export default new CommonApi();
